import create from 'zustand';
import produce from 'immer';

import Transform from 'utils/securities/transformData';
import { getPortfolioDetail } from 'global/Securities/api/portfolio';
import type { PortfolioStateItem } from 'global/Securities/types/store/portfolio';

export type DataTypes = PortfolioStateItem;

interface State {
  data: DataTypes;
  dayTrade: DataTypes;
  isLoading: boolean;
}

interface Action {
  setCurrentSymbol(symbol: string): void;
  loadPortfolioDetail: (symbol: string) => Promise<DataTypes>;
  resetPortfolioDetail: () => void;
  updatePortfolioDetail: (
    newData: Partial<PortfolioStateItem>,
    checkSymbol?: boolean,
    isDayTrade?: boolean,
  ) => void;
}

const initialState: State = {
  data: {} as DataTypes,
  dayTrade: {} as DataTypes,
  isLoading: false,
};

const usePortfolioDetailStore = create<State & Action>((set, get) => ({
  ...initialState,
  setCurrentSymbol: (symbol) => {
    set({ data: { symbol } as DataTypes });
  },
  loadPortfolioDetail: async (symbol) => {
    try {
      set({ isLoading: true });

      const axiosResponse = await getPortfolioDetail(symbol);
      const { data: responseData } = axiosResponse.data;
      const { result, day_trade } = responseData;
      const data = Transform.portfolioItem(result);
      const dataDaytrade = Transform.portfolioItem(day_trade);

      set({ data, dayTrade: dataDaytrade, isLoading: false });

      return data;
    } catch (error) {
      set({ isLoading: false });
      return Promise.reject(error);
    }
  },
  resetPortfolioDetail: () => {
    set(initialState);
  },
  updatePortfolioDetail: (newData, checkSymbol = true, isDayTrade = false) => {
    if (typeof newData !== 'object') return;

    const currentSymbol = get().data?.symbol;

    if (currentSymbol !== newData.symbol && checkSymbol) return;
    set(
      produce<State>((state) => {
        if (isDayTrade) {
          state.dayTrade = { ...state.dayTrade, ...newData };
        } else {
          state.data = { ...state.data, ...newData };
        }
      }),
    );
  },
}));

export default usePortfolioDetailStore;
